import React, { Component } from "react";
import { model } from "../data";
import { mapNameToPicklistValue, prepareSelectableOptions } from "~/admin/utils";
import { messages } from "../../i18n-messages";
import { InjectedIntlProps } from "@ai360/core/intl";
import { createAddLinkLabelText, createAddEditModalTitle } from "~/i18n-messages";
// Components
import { DialogBox, DialogBoxFooterType, NoLink, SelectInput, ZeroToInfiniteGrid } from "~/core";
import { withEditableGrid } from "~/hocs";
import { adminData, GUID, ID, NAME, VALUE } from "~/admin/data";
// Constants
// Types
import { ITraitGeneState, ITraitGeneProps } from "../interfaces";

interface ITraitGeneListState extends ITraitGeneState {
    lastOptions: any[] | null;
    lastRecord: any[] | null;
    records: any[];
}

class TraitGene extends Component<ITraitGeneProps & InjectedIntlProps, ITraitGeneListState> {
    constructor(props) {
        super(props);
        this.state = {
            editOptions: [],
            editingItem: false,
            records: [],
            lastRecord: null,
            lastOptions: null,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { record, options } = nextProps;
        if (record === prevState.lastRecord && options === prevState.lastOptions) {
            return null;
        }
        const records = (record || []).map((recordItem) => {
            const selectedTraitGeneName = (options || []).find((traitGeneItem) => {
                return traitGeneItem.name === recordItem[model.PROPS_GENE_NAME];
            });
            return {
                ...recordItem,
                [model.PROPS_GENE_NAME]:
                    (selectedTraitGeneName && selectedTraitGeneName[NAME]) ||
                    recordItem[model.PROPS_GENE_NAME],
            };
        });
        return {
            records,
            lastRecord: record,
            lastOptions: options,
        };
    }

    initializeDropdowns = (options) => {
        this.setState({
            editOptions: prepareSelectableOptions(options, {
                guid: GUID,
                label: NAME,
                id: ID,
            }),
        });
    };

    onEdit = (record, index) => {
        this.initializeDropdowns(this.props.options);
        this.setState({ editingItem: true });
        const keysToUpdate = [
            {
                name: [model.PROPS_GENE_NAME],
                key: VALUE,
            },
        ];
        this.props.onEdit({ record, index, keysToUpdate });
    };

    onDelete = (record, index) => {
        this.props.onDelete({ record, index });
    };

    onAdd = () => {
        this.initializeDropdowns(this.props.options);
        this.setState({ editingItem: false });
        this.props.onAdd();
    };

    renderAddEditModal = () => {
        const { formatMessage, isEditing, editData, onAddOrEditItem, toggleModal } = this.props;
        return (
            <DialogBox
                action="save"
                actionDisabled={!editData[model.PROPS_GENE_NAME]}
                footerType={DialogBoxFooterType.ACTION_CANCEL}
                forceOverflow
                isOpen={isEditing}
                onAction={() => onAddOrEditItem()}
                onClose={() => toggleModal("isEditing", false)}
                title={createAddEditModalTitle(
                    this.state.editingItem,
                    formatMessage,
                    messages.traitGene
                )}
                testId="trait-gene-add-edit-modal"
            >
                <SelectInput
                    required
                    tabIndex={0}
                    autoFocus
                    optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                    openOnFocus={false}
                    options={this.state.editOptions}
                    placeholderText={formatMessage(messages.geneName)}
                    value={mapNameToPicklistValue({
                        options: this.state.editOptions,
                        selectedName: editData[model.PROPS_GENE_NAME],
                    })}
                    onChange={(value) => {
                        this.props.onChange({
                            [model.PROPS_GENE_NAME]: value ? value.name : "",
                        });
                    }}
                    testId="trait-gene-gene-name-select"
                />
            </DialogBox>
        );
    };

    render() {
        const { formatMessage, renderDeleteModal } = this.props;
        const { records } = this.state;
        return (
            <div className={"form-section-child-stretch mini-grid"}>
                {records && records.length > 0 && (
                    <ZeroToInfiniteGrid
                        records={records}
                        columns={{
                            [model.PROPS_GENE_NAME]: {
                                title: formatMessage(messages.name),
                            },
                        }}
                        className={"cell-stretch"}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        showHeader={false}
                    />
                )}
                {this.renderAddEditModal()}
                {renderDeleteModal()}
                <div className="add-link-container">
                    <NoLink
                        className="add-link"
                        label={createAddLinkLabelText(formatMessage, messages.traitGene)}
                        onClick={this.onAdd}
                    ></NoLink>
                </div>
            </div>
        );
    }
}

export default withEditableGrid(TraitGene);
